<template>
  <div class="container-xxl business-page py-5">
    <div class="container">
      <div class="business-hero">
        <div>
          <h6 class="section-title text-start text-primary text-uppercase">İlanlar</h6>
          <h1>Ankara Ağrılılar Derneği ilan panosu</h1>
          <p>
            Hemşehrilerimizin satılık, kiralık, duyuru, fırsat ve ihtiyaç
            ilanlarını tek yerde topluyoruz. İlan sahipleriyle doğrudan iletişime
            geçebilir, yeni ilan vermek için dernek hattına WhatsApp üzerinden
            ulaşabilirsiniz.
          </p>
        </div>
        <div class="business-summary">
          <span>{{ ILANLAR.length }}</span>
          <strong>Yayındaki ilan</strong>
          <small>Hemşehri ilan ve duyuru panosu</small>
        </div>
      </div>

<div class="business-toolbar">
  <div class="business-search">
    <i class="fa fa-search"></i>
    <input
      v-model.trim="searchTerm"
      type="search"
      placeholder="İlan, kategori veya iletişim ara"
      aria-label="İlanlarda ara"
    >
  </div>
  <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
    <i class="fab fa-whatsapp me-2"></i>İlan Ekle
  </a>
</div>

<div class="business-seo-strip">
  <span>Ankara Ağrılı ilanlar</span>
  <span>Satılık ve kiralık duyurular</span>
  <span>Hemşehri ilan panosu</span>
  <span>Güvenilir iletişim ağı</span>
</div>

<div class="business-layout">
  <aside class="business-note">
    <i class="fa fa-bullhorn"></i>
    <h2>Hemşehri ilan panosu</h2>
    <p>
      Bu sayfa Ankara'daki Ağrılı hemşehrilerimizin duyuru ve ilanlarını daha
      görünür kılmak için hazırlanmıştır. Yeni ilan eklemek veya mevcut ilanın
      güncellenmesini istemek için dernek hattına ulaşabilirsiniz.
    </p>
    <div class="business-note-meta">
      <span><i class="fa fa-phone-alt"></i> Tek dokunuşla arama</span>
      <span><i class="fab fa-whatsapp"></i> WhatsApp mesajı</span>
      <span><i class="fa fa-bullhorn"></i> İlan başlığı</span>
      <span><i class="fa fa-tags"></i> Kategori bilgisi</span>
    </div>
  </aside>


        <div class="business-list">
          <article
            v-for="(item, index) in filteredIlanlar"
            :key="item.title"
            class="business-row"
          >
            <div class="business-index">{{ String(index + 1).padStart(2, '0') }}</div>
            <div class="business-content">
              <div class="business-row-head">
                <div>
                  <h2>{{ item.title }}</h2>
                  <p>{{ getExcerpt(item.desciption) }}</p>
                </div>
                <div class="business-categories">
                  <span v-for="cat in getCategories(item.category)" :key="cat">{{ cat }}</span>
                </div>
              </div>

              <div class="business-info-grid">
                <a :href="`tel:${normalizePhone(item.phone)}`">
                  <i class="fa fa-phone-alt"></i>
                  <span>{{ item.phone }}</span>
                </a>
              </div>

              <div class="business-actions">
                <a class="btn btn-primary" :href="`tel:${normalizePhone(item.phone)}`">
                  <i class="fa fa-phone-alt me-2"></i>Ara
                </a>
                <a v-if="hasWhatsapp(item.phone)" class="btn btn-success" :href="getWhatsappUrl(item)" target="_blank" rel="noopener">
                  <i class="fab fa-whatsapp me-2"></i>WhatsApp
                </a>
  
              </div>
            </div>
          </article>

          <div v-if="filteredIlanlar.length === 0" class="business-empty">
            <i class="fa fa-search"></i>
            <h2>Sonuç bulunamadı</h2>
            <p>Arama metnini değiştirerek tekrar deneyebilirsiniz.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import ILANLAR from '@/data/ilanlar';

const searchTerm = ref('');
const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden ulaştım, ilan ekletmek istiyorum.')}`;

const filteredIlanlar = computed(() => {
  const term = searchTerm.value.toLocaleLowerCase('tr-TR');

  if (!term) {
    return ILANLAR;
  }

  return ILANLAR.filter((item) => {
    return [
      item.title,
      item.desciption,
      item.phone,
      item.category
    ].join(' ').toLocaleLowerCase('tr-TR').includes(term);
  });
});

function getCategories(category) {
  if (!category) return [];
  return category.split(',').map((item) => item.trim()).filter(Boolean);
}

function normalizePhone(phone) {
  return String(phone || '').replace(/\s/g, '');
}

function normalizeWhatsappPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.startsWith('90')) return digits;
  if (digits.startsWith('0')) return `90${digits.slice(1)}`;
  return `90${digits}`;
}

function hasWhatsapp(phone) {
  return normalizePhone(phone).replace(/\D/g, '').replace(/^90/, '').replace(/^0/, '').startsWith('5');
}

function getWhatsappUrl(item) {
  const message = `Merhaba, Ankara Ağrılılar Derneği web sitesindeki ${item.title} ilanı hakkında bilgi almak istiyorum.`;
  return `https://wa.me/${normalizeWhatsappPhone(item.phone)}?text=${encodeURIComponent(message)}`;
}

function getExcerpt(text) {
  const cleanText = String(text || '').replace(/\s+/g, ' ').trim();

  if (cleanText.length <= 220) {
    return cleanText;
  }

  return `${cleanText.slice(0, 220)}...`;
}
</script>

<style scoped>
.business-page {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 48%, #FFFFFF 100%);
}

.business-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 230px;
  gap: 32px;
  align-items: end;
  margin-bottom: 28px;
}

.business-hero h1 {
  color: var(--dark);
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.08;
  max-width: 900px;
  margin: 0 0 18px;
}

.business-hero p {
  color: #5B6475;
  font-size: 18px;
  line-height: 1.7;
  max-width: 820px;
  margin: 0;
}

.business-summary {
  background: var(--dark);
  color: #FFFFFF;
  min-height: 190px;
  padding: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(15, 23, 43, .14);
}

.business-summary span {
  color: var(--primary);
  font-size: 58px;
  font-weight: 800;
  line-height: 1;
}

.business-summary strong {
  font-size: 20px;
  margin-top: 10px;
}

.business-summary small {
  color: rgba(255, 255, 255, .76);
  margin-top: 8px;
}

.business-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.business-search {
  flex: 1;
  min-height: 56px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .1);
  border-radius: 8px;
  padding: 0 18px;
  box-shadow: 0 10px 26px rgba(15, 23, 43, .06);
}

.business-search i {
  color: var(--primary);
}

.business-search input {
  width: 100%;
  border: 0;
  outline: 0;
  color: var(--dark);
  background: transparent;
  font-size: 16px;
}

.business-seo-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 28px;
}

.business-seo-strip span {
  color: #344054;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 3px solid var(--primary);
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  padding: 8px 12px;
}

.business-layout {
  display: grid;
  grid-template-columns: 310px minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

.business-note {
  position: sticky;
  top: 118px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 14px 35px rgba(15, 23, 43, .08);
}

.business-note > i {
  color: var(--primary);
  font-size: 34px;
  margin-bottom: 18px;
}

.business-note h2,
.business-empty h2 {
  color: var(--dark);
  font-size: 24px;
  margin-bottom: 12px;
}

.business-note p,
.business-empty p {
  color: #606A7A;
  line-height: 1.7;
}

.business-note-meta {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.business-note-meta span {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #344054;
  font-weight: 600;
}

.business-note-meta i {
  color: var(--primary);
  width: 18px;
}

.business-list {
  display: grid;
  gap: 14px;
}

.business-row {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 18px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 10px 28px rgba(15, 23, 43, .06);
}

.business-index {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #FFF4DF;
  color: var(--primary);
  font-weight: 800;
  border-radius: 50%;
}

.business-content {
  min-width: 0;
}

.business-row-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  align-items: start;
}

.business-row-head h2 {
  color: var(--dark);
  font-size: 23px;
  margin: 0 0 8px;
}

.business-row-head p {
  color: #5F6979;
  line-height: 1.65;
  margin: 0;
}

.business-categories {
  max-width: 260px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.business-categories span {
  color: #7A4C00;
  background: #FFF4DF;
  border: 1px solid #FFE2AA;
  font-size: 12px;
  font-weight: 700;
  padding: 7px 9px;
  border-radius: 999px;
}

.business-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 18px 0;
}

.business-info-grid div,
.business-info-grid a {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: #465166;
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .06);
  border-radius: 8px;
  padding: 12px;
  min-width: 0;
}

.business-info-grid a:hover {
  color: var(--dark);
  border-color: rgba(254, 161, 22, .35);
  background: #FFF9EF;
}

.business-info-grid i {
  color: var(--primary);
  margin-top: 4px;
}

.business-info-grid span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.business-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.business-actions .btn,
.business-toolbar .btn {
  min-height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 10px 18px;
}

.business-empty {
  background: #FFFFFF;
  border: 1px dashed rgba(15, 23, 43, .18);
  border-radius: 8px;
  padding: 34px;
  text-align: center;
}

.business-empty i {
  color: var(--primary);
  font-size: 34px;
  margin-bottom: 16px;
}

@media (max-width: 991.98px) {
  .business-hero,
  .business-layout {
    grid-template-columns: 1fr;
  }

  .business-summary {
    min-height: auto;
  }

  .business-note {
    position: static;
  }

  .business-row-head,
  .business-info-grid {
    grid-template-columns: 1fr;
  }

  .business-categories {
    max-width: none;
    justify-content: flex-start;
  }
}

@media (max-width: 575.98px) {
  .business-page {
    padding-bottom: 86px !important;
  }

  .business-hero h1 {
    font-size: 32px;
  }

  .business-hero p {
    font-size: 16px;
  }

  .business-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .business-toolbar .btn,
  .business-actions .btn {
    width: 100%;
  }

  .business-row {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .business-index {
    width: 40px;
    height: 40px;
  }

  .business-row-head h2 {
    font-size: 20px;
  }
}
</style>
